export default __webpack_public_path__ + "static/media/falconator.ab3c8532.svg";